<template>

	<div class="abow_wbox bkf7">
		<div class="inter">
			<div class="sell_wbox">
				<div class="wp1">新增出租账号</div>
				<div class="wp2">请按照指引填写账号信息，提交后将进入审核</div>
				<div class="div1" v-if="show">
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">



						<!-- <div class="n_div"  style="">
							<div class="ti"><span>基础信息</span></div>
							<div class="n_con">
								<el-form-item label="" prop="title">
									<el-input class="in1" v-model="ruleForm.title"
										placeholder="请输入标题，标题请包含账号亮点，方便审核与展示"></el-input>
								</el-form-item>
							</div>
						</div> -->

						<div class="n_div">
							<div class="ti"><span>账号属性</span></div>
							<div class="n_div2">
								<div class="np1">核心资产信息</div>
								<div class="field_sell_1">
									<div class="item">
										<div class="p1">
											<span>*</span>游戏区服:
										</div>
										<div class="text">
											<el-form-item label="" prop="qufu">
												<el-radio-group v-model="ruleForm.qufu">
													<el-radio v-for="(item, index) in field.qufu.content" :key="index"
														:label="item.value" v-if="item.value !== ''">
														{{ item.title }}
													</el-radio>
												</el-radio-group>
											</el-form-item>

										</div>
									</div>
									<div class="item">
										<div class="p1">
											<span>*</span>哈夫币纯币(M):
										</div>
										<div class="text">
											<el-form-item label="" prop="chunbi">
												<el-input v-model="ruleForm.chunbi" placeholder="请输入纯币数量"></el-input>
											</el-form-item>
											<div class="desc">
												<span>温馨提示:</span>纯币数量少于20M无法上架，大于300M建议按照1/44以上的比例进行挂牌
											</div>
										</div>
									</div>
									<div class="item">
										<div class="p1">
											<span>*</span>仓库总资产(M):
										</div>
										<div class="text">
											<el-form-item label="" prop="zichan">
												<el-input v-model="ruleForm.zichan" placeholder="请输入总资产"></el-input>
											</el-form-item>
											<div class="desc">
												<span>温馨提示:</span>仓库内白色/紫色物资请清空，避免保留超过20M的物资
											</div>
										</div>
									</div>
									<div class="item">
										<div class="p1">
											<span>*</span>安全箱:
										</div>
										<div class="text">
											<el-form-item label="" prop="box">
												<el-select v-model="ruleForm.box" placeholder="请选择">
													<el-option :label="item.title" :value="item.value"
														v-for="item, index in field.box.content"
														v-if="item.value != ''"></el-option>
												</el-select>
											</el-form-item>

											<div class="desc">
												<span>温馨提示:</span>如实按照赛季安全箱填写，否则影响结算价格，建议至少有6格保险。9格体验卡，请在备注一栏写明体验卡天数，否则会影响结算价格。
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="n_div2">
								<div class="np1">练度信息</div>
								<div class="field_sell_1">
									<div class="item">
										<div class="p1">
											<span>*</span>训练中心:
										</div>
										<div class="text">
											<el-form-item label="" prop="xunlian">
												<el-select v-model="ruleForm.xunlian" placeholder="请选择">
													<el-option :label="item.title" :value="item.value"
														v-for="item, index in field.xunlian.content"
														v-if="item.value != ''"></el-option>
												</el-select>
											</el-form-item>
										</div>
									</div>
									<div class="item">
										<div class="p1">
											<span>*</span>靶场等级:
										</div>
										<div class="text">
											<el-form-item label="" prop="bachang">
												<el-select v-model="ruleForm.bachang" placeholder="请选择">
													<el-option :label="item.title" :value="item.value"
														v-for="item, index in field.bachang.content"
														v-if="item.value != ''"></el-option>
												</el-select>
											</el-form-item>

										</div>
									</div>
									<div class="item">
										<div class="p1">
											<span>*</span>账号等级:
										</div>
										<div class="text">
											<el-form-item label="" prop="level">
												<el-input v-model="ruleForm.level" placeholder="0-60"></el-input>
											</el-form-item>
											<div class="desc">
												<span>温馨提示:</span>账号等级低于30无法寄售租赁
											</div>
										</div>
									</div>
									<div class="item">
										<div class="p1">
											<span>*</span>账号段位:
										</div>
										<div class="text">
											<el-form-item label="" prop="duanwei">
												<el-select v-model="ruleForm.duanwei" placeholder="请选择">
													<el-option :label="item.title" :value="item.value"
														v-for="item, index in field.duanwei.content"
														v-if="item.value != ''"></el-option>
												</el-select>
											</el-form-item>
										</div>
									</div>
								</div>
							</div>






							<div class="n_div2">
								<div class="np1">特殊物资配置(选填)</div>
								<div class="field_sell_1">

									<div class="item item2">
										<div class="p1">
											AWM子弹数:
										</div>
										<div class="text">
											<el-form-item label="" prop="awm">
												<el-input v-model="ruleForm.awm" placeholder="0-60"></el-input>
											</el-form-item>
											<div class="desc">
												<span>温馨提示:</span>建议单价0.4-1.2元/发(自行与打手沟通)，价越低出越快
											</div>
										</div>
									</div>
									<div class="item item2">
										<div class="p1">
											六套数量:
										</div>
										<div class="text">
											<el-form-item label="" prop="liutao">
												<el-input v-model="ruleForm.liutao" placeholder="0-60"></el-input>
											</el-form-item>
											<div class="desc">
												<span>温馨提示:</span>建议单价4-6元/套(自行与打手沟通)，价越低出越快
											</div>
										</div>
									</div>

								</div>
							</div>


							<div class="n_div2">
								<div class="np1">账号KD 实名 风控</div>
								<div class="field_sell_1">

									<div class="item">
										<div class="p1">
											<span>*</span>账号KD:
										</div>
										<div class="text">
											<el-form-item label="" prop="kd">
												<el-input v-model="ruleForm.kd" placeholder="例如1.35"></el-input>
											</el-form-item>
											<div class="desc">
												<span>温馨提示:</span>请填写绝密 KD
											</div>
										</div>
									</div>
									<div class="item">
										<div class="p1">
											<span>*</span>常用登陆地:
										</div>
										<div class="text">
											<el-form-item label="" prop="changzhu">
												<el-select v-model="ruleForm.changzhu" placeholder="请选择">
													<el-option :label="item.title" :value="item.value"
														v-for="item, index in field.changzhu.content"
														v-if="item.value != ''"></el-option>
												</el-select>
											</el-form-item>
										</div>
									</div>
									<div class="item">
										<div class="p1">
											<span>*</span>是否本人人脸:
										</div>
										<div class="text">
											<el-form-item label="" prop="is_ben">
												<el-radio-group v-model="ruleForm.is_ben">
													<el-radio v-for="(item, index) in field.is_ben.content" :key="index"
														:label="item.value" v-if="item.value !== ''">
														{{ item.title }}
													</el-radio>
												</el-radio-group>
											</el-form-item>

										</div>
									</div>
									<div class="item">
										<div class="p1">

											<span>*</span>是否存在封禁:
										</div>
										<div class="text">
											<el-form-item label="" prop="is_feng">
												<el-radio-group v-model="ruleForm.is_feng">
													<el-radio v-for="(item, index) in field.is_feng.content"
														:key="index" :label="item.value" v-if="item.value !== ''">
														{{ item.title }}
													</el-radio>
												</el-radio-group>
											</el-form-item>

										</div>
									</div>

								</div>
							</div>



							<div class="n_div2">
								<div class="np1">皮肤</div>
								<div class="field_sell_1">

									<div class="item item3">
										<div class="p1">
											干员皮肤:
										</div>
										<div class="text">
											<el-form-item label="" prop="ganyuan">
												<el-select multiple v-model="ruleForm.ganyuan" placeholder="请选择">
													<el-option :label="item.title" :value="item.value"
														v-for="item, index in field.ganyuan.content"
														v-if="item.value != ''"></el-option>
												</el-select>
											</el-form-item>
										</div>
									</div>
									<div class="item item3">
										<div class="p1">
											刀皮:
										</div>
										<div class="text">
											<el-form-item label="" prop="daopi">
												<el-select multiple v-model="ruleForm.daopi" placeholder="请选择">
													<el-option :label="item.title" :value="item.value"
														v-for="item, index in field.daopi.content"
														v-if="item.value != ''"></el-option>
												</el-select>
											</el-form-item>
										</div>
									</div>
									<div class="item  item3">
										<div class="p1">
											武器皮肤:
										</div>
										<div class="text">
											<el-form-item label="" prop="wuqi">
												<el-select multiple v-model="ruleForm.wuqi" placeholder="请选择">
													<el-option :label="item.title" :value="item.value"
														v-for="item, index in field.wuqi.content"
														v-if="item.value != ''"></el-option>
												</el-select>
											</el-form-item>
										</div>
									</div>



								</div>
							</div>


							<div class="n_div2">
								<div class="np1">补充信息</div>
								<div class="field_sell_1" style="margin-bottom: 10px;">
									<div class="item item2">
										<div class="p1">
											商品备注:
										</div>
										<div class="text">
											<el-form-item label="" prop="beizhu">
												<el-input v-model="ruleForm.beizhu" placeholder="请输入备注"></el-input>
											</el-form-item>
										</div>
									</div>
									<div class="item item2">
										<div class="p1">
											禁止项:
										</div>
										<div class="text">
											<el-form-item label="" prop="jingzhi">
												<el-input v-model="ruleForm.jingzhi" placeholder="请输入禁止项"></el-input>
											</el-form-item>
										</div>
									</div>
								</div>
								<div class="field_sell_1">

									<div class="item item2">
										<div class="p1">
											方便交易时间:
										</div>
										<div class="text">
											<el-form-item label="" prop="jiaoyi">



												<el-time-picker is-range format="HH:mm" value-format="HH:mm"
													v-model="ruleForm.jiaoyi" range-separator="-"
													start-placeholder="开始时间" end-placeholder="结束时间"
													placeholder="选择时间范围">
												</el-time-picker>


											</el-form-item>
										</div>

									</div>
									<div class="item item2">
										<div class="p1">
											比例(最低30.系统自动计管租金)
										</div>


										<div class="text">
											<el-form-item label="" prop="bili">
												<el-input v-model="ruleForm.bili" readonly
													placeholder="自动计算"></el-input>
											</el-form-item>
										</div>
										<div class="desc">
											<span>温馨提示:</span>回收比例 7体9格40、7体6格42、7体4格43、5/6体9格42、5/6体6格44、3/4体9格44，其余全部
											45。急需出手可调高比例提升成交速度;如有怜悯、赤霄、信条可在正常比例基础上下调2点，但最低30。
										</div>
									</div>
								</div>

								<div class="field_sell_1">
									<div class="item item4">
										<div class="p1">
											<span>*</span>账号截图
										</div>
										<div class="text">


											<!-- 多图上传组件核心 -->
											<el-upload class="image-uploader" :action="`${api_url}/api/common/upload`"
												:multiple="true" :file-list="imageList"
												:on-success="handleUploadSuccess" :on-remove="handleRemoveImage"
												:before-upload="beforeUpload" list-type="picture-card"
												:on-preview="handlePreviewImage">
												<i class="el-icon-plus"></i>
											</el-upload>



										</div>
										<div class="desc">
											<span>温馨提示:</span>禁为避免交易纠纷，建议上传仓库保留物，KD界面、收藏室、藏品界面截图，出租成功后也需在交易群内同步发送
										</div>
									</div>

								</div>
							</div>


							<div class="n_div3">

								<div class="w_item">
									<div class="n_div">
										<div class="field_sell_1" style="margin-bottom: 10px;">
											<div class="item item4">
												<div class="p1">
													<span>*</span>租金:
												</div>
												<div class="text">
													<el-form-item label="" prop="price">
														<el-input v-model="ruleForm.price" readonly
															placeholder="自动计算"></el-input>
													</el-form-item>
												</div>
												<div class="desc">
													<span>温馨提示:</span>提现费率为 1%
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="w_item">
									<div class="n_div">
										<div class="field_sell_1" style="margin-bottom: 10px;">
											<div class="item item4">
												<div class="p1">
													<span>*</span>租期(天):
												</div>
												<div class="text">
													<el-form-item label="" prop="zuqi">
														<el-input v-model="ruleForm.zuqi" readonly
															placeholder="请输入"></el-input>
													</el-form-item>
												</div>
												<div class="desc">
													<span>温馨提示:</span>此为最长使用期限，按纯币10M/天估算;租客提前用完可申请提前结算
												</div>
											</div>
										</div>
									</div>
								</div>

								<div class="w_item">
									<div class="n_div">
										<div class="field_sell_1" style="margin-bottom: 10px;">
											<div class="item item4">
												<div class="p1">
													<span>*</span>押金:
												</div>
												<div class="text">
													<el-form-item label="" prop="yajin">
														<el-input v-model="ruleForm.yajin"
															placeholder="请输入备注"></el-input>
													</el-form-item>
												</div>
												<div class="desc">
													<span>温馨提示:</span>押金供打手上交，若封禁30天赔付押金30%，封禁10年需赔付全部租金及押金
												</div>
											</div>
										</div>
									</div>
								</div>


							</div>


							<div class="n_div4">
								<div class="text">

									<div class="ic">
										<el-checkbox-group v-model="mychose">
											<el-checkbox label=""></el-checkbox>

										</el-checkbox-group>
									</div>
									<div class="sp1">
										我已阅读并同意 <span @click="visible3 = true">
											《用户协议》</span>及 <span @click="visible2 = true">《隐私政策》</span>

									</div>
								</div>
								<div class="text_2">
									<button class="form_btn" type="button" @click="submitForm('ruleForm')">立即发布</button>
								</div>
							</div>

							<div class="n_div5">



								<img src="@/assets/image/sell_img.jpg" />
							</div>

						</div>







					</el-form>

				</div>
			</div>
		</div>


		<el-dialog :visible.sync="visible2" :center="true" title="隐私协议" width="600px" destroy-on-close
			@closed="visible2 = false">
			<div class="compensationModel_box">
				<div v-html="config.yingsi">

				</div>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="visible3" :center="true" title="用户协议" width="600px" destroy-on-close
			@closed="visible3 = false">
			<div class="compensationModel_box">
				<div v-html="config.yonghu">

				</div>
			</div>
		</el-dialog>

		<el-dialog :visible.sync="previewDialogVisible">
			<img width="100%" :src="previewImageUrl" alt="">
		</el-dialog>


	</div>

</template>


<script>
import { parseFloat } from 'core-js/core/number';
import { Button, Input } from 'element-ui';

export default {
	data() {
		return {
			field: [],
			num: 0,
			mychose: [],
			visible2: false,
			visible3: false,
			model: [],
			gameid: 30,
			ruleForm: {
				title: "",
				qufu: "",
				chunbi: "",
				zichan: "",
				duanwei: "",
				box: "",
				xunlian: "",
				bachang: "",
				level: "",
				is_ben: "",
				is_feng: "",
				awm: "",
				liutao: "",
				kd: "",
				changzhu: "",
				daopi: "",
				wuqi: "",
				ganyuan: "",
				beizhu: "",
				jingzhi: "",
				jiaoyi: [new Date(), new Date()],
				bili: "",
				price: "",
				zuqi: "",
				yajin: "",
				images: "",


			},

			show: false,
			rules: {

				// title: [
				// 	{ required: true, message: '请输入', trigger: 'blur' },
				// ],
				qufu: [
					{ required: true, message: '请选择游戏区服', trigger: 'blur' },
				],
				chunbi: [
					{ required: true, message: '请输入纯币数量', trigger: 'blur' },
					{
						pattern: /^[0-9]+(\.[0-9]{1,2})?$/,
						message: '纯币请输入有效的数字',
						trigger: 'blur'
					},
					{
						validator: (rule, value, callback) => {
							// 空值由required规则处理
							if (!value) return callback();

							const zichanValue = this.ruleForm.zichan;
							// 转换为数字进行比较
							const chunbiNum = Number(value);
							const zichanNum = Number(zichanValue);

							// 验证逻辑：纯币必须小于总资产
							if (zichanValue && !isNaN(zichanNum) && !isNaN(chunbiNum)) {
								if (chunbiNum >= zichanNum) {
									callback(new Error('纯币数量必须小于总资产'));
								} else {
									callback();
								}
							} else {
								callback();
							}
						},
						trigger: 'blur'
					}
				],
				zichan: [
					{ required: true, message: '请输入总资产', trigger: 'blur' },
					{
						pattern: /^[0-9]+(\.[0-9]{1,2})?$/,
						message: '总资产请输入有效的数字',
						trigger: 'blur'
					},
					{
						validator: (rule, value, callback) => {
							// 空值由required规则处理
							if (!value) return callback();

							const chunbiValue = this.ruleForm.chunbi;
							// 转换为数字进行比较
							const zichanNum = Number(value);
							const chunbiNum = Number(chunbiValue);

							// 验证逻辑：总资产必须大于纯币
							if (chunbiValue && !isNaN(chunbiNum) && !isNaN(zichanNum)) {
								if (zichanNum <= chunbiNum) {
									callback(new Error('总资产必须大于纯币数量'));
								} else {
									callback();
								}
							} else {
								callback();
							}
						},
						trigger: 'blur'
					}
				],
				box: [
					{ required: true, message: '请选择安全箱', trigger: 'blur' },
				],
				xunlian: [
					{ required: true, message: '请选择等级', trigger: 'blur' },
				],
				bachang: [
					{ required: true, message: '请选择等级', trigger: 'blur' },
				],
				level: [
					{ required: true, message: '请输入账号等级', trigger: 'blur' },
				],
				duanwei: [
					{ required: true, message: '请选择段位', trigger: 'blur' },
				],
				kd: [
					{ required: true, message: '请输入账号KD', trigger: 'blur' },
				],
				changzhu: [
					{ required: true, message: '请选择常驻登陆地', trigger: 'blur' },
				],
				is_ben: [
					{ required: true, message: '请选择是否本人人脸', trigger: 'blur' },
				],
				is_feng: [
					{ required: true, message: '请选择是否封禁', trigger: 'blur' },
				],
				price: [
					{ required: true, message: '请输入租金', trigger: 'blur' },
				],
				zuqi: [
					{ required: true, message: '请输入租期', trigger: 'blur' },
				],
				yajin: [
					{ required: true, message: '请输入押金', trigger: 'blur' },
				],
			},
			imageList: [], // 核心：存储符合 el-upload 规范的文件对象数组
			previewDialogVisible: false, // 预览弹窗显隐
			previewImageUrl: '', // 预览图片地址
			goods_id: ""

		}
	},
	computed: {

		config() {
			return this.$store.getters.config
		},
	},
	created: function (data) {
		this.goods_id = 0;


		if (this.$route.query.id) {
			this.goods_id = this.$route.query.id
			this.getInfo();
		}


		this.show = false
		this.Filed();

	},
	watch: {
		$route() {

		},
		// 核心：用字符串包裹嵌套属性路径
		'ruleForm.xunlian'(newVal, oldVal) {

			this.ruleForm.bili = this.calculateRatio()
			// 这里写你需要执行的逻辑，比如校验、请求接口等
		},
		'ruleForm.bangchang'(newVal, oldVal) {

			this.ruleForm.bili = this.calculateRatio()
			// 这里写你需要执行的逻辑，比如校验、请求接口等
		},
		'ruleForm.daopi'(newVal, oldVal) {

			this.ruleForm.bili = this.calculateRatio()
			// 这里写你需要执行的逻辑，比如校验、请求接口等
		},
		'ruleForm.ganyuan'(newVal, oldVal) {

			this.ruleForm.bili = this.calculateRatio()
			// 这里写你需要执行的逻辑，比如校验、请求接口等
		},
		'ruleForm.box'(newVal, oldVal) {

			this.ruleForm.bili = this.calculateRatio()
			// 这里写你需要执行的逻辑，比如校验、请求接口等
		},
		'ruleForm.chunbi'(newVal, oldVal) {

			if (this.ruleForm.bili != '') {

				var chunbi = newVal;
				var bili = this.ruleForm.bili;

				chunbi = chunbi * 100
				var price = chunbi / bili
				price = Number(price).toFixed(0)
				this.ruleForm.price = price

				this.calculateYajin()

			}
			var zuqi = Number(newVal).toFixed(0) / 10
			this.ruleForm.zuqi = Number(zuqi).toFixed(0)


		},
		'ruleForm.zichan'(newVal, oldVal) {
			this.calculateYajin()
		},
		'ruleForm.daopi'(newVal, oldVal) {
			this.calculateYajin()
		},
		'ruleForm.wuqi'(newVal, oldVal) {
			this.calculateYajin()
		},
		'ruleForm.bili'(newVal, oldVal) {

			if (this.ruleForm.chunbi != '') {

				var chunbi = this.ruleForm.chunbi;
				var bili = newVal;

				chunbi = chunbi * 100
				var price = chunbi / bili
				price = Number(price).toFixed(0)
				this.ruleForm.price = price


				this.calculateYajin()


			}
		}
	},
	methods: {
		calculateYajin() {


			if (this.ruleForm.zichan == '') {
				return;
			}
			if (this.ruleForm.bili == '') {
				return;
			}
			if (this.ruleForm.chunbi == '') {
				return;
			}


			var cangku = this.ruleForm.zichan
			var yajin = 0;
			var zichan = 0;
			var chunbi = Number(this.ruleForm.chunbi)
			var bili = Number(this.ruleForm.bili)
			zichan = Number(cangku) - Number(chunbi)
			yajin = zichan / bili
			yajin = Number(yajin) || 0;
			// 保留 0 位小数
			yajin = yajin.toFixed(0);
			var daoprice = 0;
			var wuqiprice = 0;

			if (this.ruleForm.daopi.length > 0) {
				daoprice = this.ruleForm.daopi.length * 300
			}
			if (this.ruleForm.wuqi.length > 0) {
				wuqiprice = this.ruleForm.wuqi.length * 800
			}

			daoprice = Number(daoprice) || 0;

			wuqiprice = Number(wuqiprice) || 0;

			yajin = Number(yajin) || 0;
			this.ruleForm.yajin = yajin + daoprice + wuqiprice
		},
		// 在 Vue2 组件的 methods 中定义这个方法
		calculateRatio() {
			const { box, bachang, xunlian, daopi, ganyuan } = this.ruleForm;

			// 1. 判断等级：7级训练中心/靶场以上为高等级，否则为低等级
			const isHighLevel = xunlian >= 7 || bachang >= 7;

			// 2. 判断是否带刀皮、砖皮（数组有元素即视为携带）
			const hasDaopi = daopi && daopi.length > 0;
			const hasGanyuan = ganyuan && ganyuan.length > 0;




			// 3. 基础比例映射表
			let baseRatio = 0;
			if (isHighLevel) {
				// 高等级（7级及以上）基础比例
				switch (box) {
					case 1: baseRatio = 40; break; // 2格保险
					case 2: baseRatio = 37; break; // 4格保险
					case 3: baseRatio = 36; break; // 6格保险
					case 4: baseRatio = 35; break; // 9格保险
					// default: throw new Error('无效的保险格子数');
				}
			} else {
				// 低等级（6级及以下）基础比例
				switch (box) {
					case 1: baseRatio = 41; break; // 2格保险
					case 2: baseRatio = 38; break; // 4格保险
					case 3: baseRatio = 37; break; // 6格保险
					case 4: baseRatio = 36; break; // 9格保险
					// default: throw new Error('无效的保险格子数');
				}
			}

			// 4. 根据刀皮、砖皮调整比例
			let finalRatio = baseRatio;
			if (hasDaopi) {
				finalRatio -= 1; // 带刀皮减1
			}
			if (hasGanyuan) {
				finalRatio -= 3; // 带砖皮减3（注意：是在带刀皮的基础上再减，而非叠加错误）
				// 验证：比如高等级9格带刀皮带砖皮 35-1-3=31，完全匹配你的规则
			}


			// 5. 返回最终比例（格式：1:finalRatio）
			return `${finalRatio}`;
		},
		// 1. 上传前校验（可选，限制图片格式/大小）
		beforeUpload(file) {
			// 限制文件类型
			const isImage = file.type.startsWith('image/');
			if (!isImage) {
				this.$message.error('只能上传图片格式（jpg/png/jpeg/gif）！');
				return false;
			}
			// 限制文件大小（5MB）
			const isLt5M = file.size / 1024 / 1024 < 5;
			if (!isLt5M) {
				this.$message.error('图片大小不能超过 5MB！');
				return false;
			}
			return true;
		},

		// 2. 上传成功回调：整理文件列表格式
		handleUploadSuccess(response, file, fileList) {


			console.log(response)


			// 假设后端返回格式：{ code: 200, data: { url: '/uploads/xxx.png' } }
			if (response.code === 1) {
				// 维护符合 el-upload 规范的文件对象数组
				this.imageList = fileList.map(item => {
					// 若接口返回的是字符串路径，转为标准对象
					if (typeof item === 'string') {
						return {
							uid: item.uid || Date.now() + Math.random().toString(36).slice(-8),
							name: item.name || item.split('/').pop(),
							url: this.fixImageUrl(item.fullurl || item),
							fullurl: this.fixImageUrl(item.url || item)
						};
					}
					// 补充接口返回的图片地址（核心：替换为后端返回的真实路径）
					if (item.raw && response.data.url) {
						let fullUrl = response.data.fullurl || response.data.url;
						item.url = this.fixImageUrl(fullUrl);
						item.fullurl = this.fixImageUrl(response.data.url);
					}
					return item;
				});
				this.$message.success('图片上传成功！');
			} else {
				this.$message.error('图片上传失败：' + response.msg);
			}
		},

		// 3. 移除图片回调：更新文件列表
		handleRemoveImage(file, fileList) {
			this.imageList = fileList;
		},

		// 4. 预览图片：打开弹窗展示大图
		handlePreviewImage(file) {

			console.log('打开图片')
			this.previewImageUrl = file.url; // 取上传成功后的真实路径
			this.previewDialogVisible = true;
		},


		tijiao() {
			if (this.mychose.length === 0) {
				this.$message.warning('《用户协议》及《隐私政策》');
				return;
			}
			const imageUrls = this.imageList.map(item => item.url);

			// 校验：确保有上传图片（可选）
			if (imageUrls.length === 0) {
				this.$message.warning('请至少上传一张图片！');
				return;
			}




			this.rq.requests.post("api/game/user/tijiao", {
				ruleForm: this.ruleForm,
				imageList: this.imageList,
				goods_id: this.goods_id
			}).then(res => {

				console.log('提交返回',res)
				if (res.code == 1) {
					// this.$message.success('提交成功等待审核');

					this.$confirm('提交成功等待审核,请问是否继续出售其他商品', '提示', {
						confirmButtonText: '继续',
						cancelButtonText: '取消',
						type: 'success'
					}).then(() => {
						location.reload()
					}).catch(() => {
						this.$router.push('/mygoods')
						
					});	

				}else{

				}

			}).catch(res => {
				if (res.code == 0) {
					this.$message.closeAll()
							// 提示
					this.$message.error(res.msg)
				}
			})


		},
		submitForm(formName) {

			this.$refs[formName].validate((valid) => {
				if (valid) {

					this.tijiao()

					// alert('submit!');
				} else {
					
					// 找到第一个校验失败的字段
					this.$refs[formName].validate((valid, fields) => {
						if (fields) {
							// 获取第一个错误字段的 key
							const firstErrorKey = Object.keys(fields)[0]
							// 获取第一个错误提示
							const firstErrorMessage = fields[firstErrorKey][0].message
							this.$message.closeAll()
							// 提示
							this.$message.error(firstErrorMessage)

							// 滚动到对应表单项
							const item = this.$refs[formName].$el.querySelector(`[prop="${firstErrorKey}"]`)
							if (item) {
								item.scrollIntoView({
									behavior: 'smooth',
									block: 'center'
								})
							}
						}
					})
					return false
					// console.log('error submit!!',valid);
					// return false;
				}
			});
		},
		getErrorFields(formName) {
			const fields = this.$refs[formName].fields
			let errorFields = []
			fields.forEach(item => {
				if (item.validateState === 'error') {
					errorFields.push(item.label || item.prop)
				}
			})
			return errorFields
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		Filed() {
			var that = this;


			this.rq.requests.post("api/game/hall/getFilterList2", {
				id: 30,
			}).then(res => {
				that.field = res.data;
				that.show = true
			}).catch(error => {

			})

		},

		getInfo() {
			var that = this;


			this.rq.requests.post("api/game/user/geMygoodstInfo", {
				id: this.goods_id,
			}).then(res => {
				if (res.code == 1) {
					this.ruleForm = res.data.addons
					this.imageList = res.data.images
				}
			}).catch(error => {

			})
		},



		fuzhi: function () {



			if (this.text.length <= 0) {
				this.$message({
					message: '复制识别内容为空',
					type: 'error'
				});
			}

			var content = "";

			for (var i = 0; i < this.$data.text.length; i++) {
				content = content + this.$data.text[i].title + ":" + this.$data.text[i].val + " \n";
			}


			const textarea = document.createElement('textarea');
			textarea.value = content;
			document.body.appendChild(textarea);

			textarea.select();
			if (document.execCommand('copy')) {
				document.execCommand('copy');


				this.$message({
					showClose: true,
					message: '复制成功请联系客服',
					type: 'success'
				});
			}

			document.body.removeChild(textarea);

		}

	}
}
</script>
